export function getSelectedDealerCountFromUrl(): number {
  const params = new URLSearchParams(window.location.search);
  const dealersParam = params.get('dealers');
  if (dealersParam) {
    const dealerIds = dealersParam.split(',').filter((id) => id.trim() !== '');
    return dealerIds.length;
  }
  return 0;
}
